import get from "lodash/get";
import {useFormContext} from "react-hook-form";

import {SelectField, SelectFieldBaseProps} from "@/components/form/fields/SelectField/SelectField.tsx";
import {VersionSelect} from "@/components/versionSelect/VersionSelect.tsx";
import {ServiceVersionDefinition} from "@/lib/types/checks.ts";

interface Props extends SelectFieldBaseProps {
  options: ServiceVersionDefinition[];
}

export const VersionField = ({name, options, ...rest}: Props) => {
  const {
    watch,
    setValue,
    formState: {defaultValues},
  } = useFormContext();
  const defaultValue = get(defaultValues, name);
  const value = watch(name);

  return (
    <SelectField
      name={name}
      {...rest}
      select={
        <VersionSelect
          value={options.find((o) => o.version.toString() === value?.toString())}
          onChange={(v) => setValue(name, v?.version, {shouldDirty: true, shouldValidate: true})}
          defaultValue={defaultValue?.toString()}
          options={options}
          isMulti={false}
        />
      }
    />
  );
};
